import styled from "@emotion/styled";

export const CustomQuoteAttachedFiles = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	"> div": {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		backgroundColor: `${theme.project.colors.primaryColors.main}14`,
		padding: "8px",
		minWidth: 0,
		"> div": {
			display: "flex",
			flexDirection: "row",
			gap: "8px",
			flex: "1 1 auto",
			minWidth: 0,
			"> div": {
				...theme.project.typography.body.body2,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-around",
				minWidth: 0,
				"> div": {
					overflow: "hidden",
					lineHeight: "36px",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
					flex: "1 1 auto",
					minWidth: 0
				}
			},
			"> div:first-of-type": {
				img: {
					width: "36px",
					height: "36px"
				}
			}
		},
		"> div:last-of-type": {
			// make icon container fixed (does not shrink) so it stays inside the row
			flex: "0 0 auto",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			paddingLeft: "8px",
			height: "36px",
			".MuiSvgIcon-root": {
				color: theme.project.colors.primaryColors.main,
				fontSize: "20px",
				lineHeight: "36px"
			}
		}
	},
	"> div:first-of-type": {
		...theme.project.typography.subtitle.subtitle2,
		padding: 0,
		backgroundColor: theme.project.colors.backgroundColors.main
	}
}));
